import { render, staticRenderFns } from "./WidgetDetailsCA.vue?vue&type=template&id=36b78fa9"
import script from "./WidgetDetailsCA.vue?vue&type=script&lang=js"
export * from "./WidgetDetailsCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports